import React from "react";

export function AdminPageHeader({ kicker, title, description, children }) {
  return (
    <header className="mb-10 flex flex-col gap-6 border-b border-white/[0.07] pb-10 md:flex-row md:items-end md:justify-between">
      <div className="min-w-0 flex-1">
        {kicker && (
          <p className="font-mono-data text-[10px] font-semibold uppercase tracking-[0.35em] text-[#CCFF00]/90">
            {kicker}
          </p>
        )}
        <h1 className="mt-1 text-2xl font-black tracking-tight text-white md:text-3xl">
          {title}
        </h1>
        {description && (
          <div className="mt-2 max-w-2xl text-sm leading-relaxed text-slate-400">
            {description}
          </div>
        )}
      </div>
      {children ? (
        <div className="flex shrink-0 flex-wrap gap-2">{children}</div>
      ) : null}
    </header>
  );
}

export function AdminCard({ children, className = "", noPadding = false }) {
  return (
    <div
      className={`pitch-admin-panel ${noPadding ? "" : "p-6 md:p-8"} ${className}`.trim()}
    >
      {children}
    </div>
  );
}

export function AdminLabel({ children, htmlFor }) {
  return (
    <label
      htmlFor={htmlFor}
      className="mb-2 block text-[10px] font-black uppercase tracking-[0.22em] text-slate-500"
    >
      {children}
    </label>
  );
}

export function SourceBadge({ source }) {
  const s = String(source || "").toLowerCase();
  const cls =
    s === "writer"
      ? "pitch-admin-badge pitch-admin-badge--writer"
      : "pitch-admin-badge pitch-admin-badge--goalise";
  const label = s === "writer" ? "Writer" : "Goalise";
  return <span className={cls}>{label}</span>;
}